import {connect} from "react-redux";
import {push} from "react-router-redux";
import {bindActionCreators} from "redux";

import SidebarLinkComponent from "./SidebarLink";

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
          push
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SidebarLinkComponent);
